import { render, staticRenderFns } from "./GoobankListComponent.vue?vue&type=template&id=96a2af34&scoped=true&"
import script from "./GoobankListComponent.vue?vue&type=script&lang=js&"
export * from "./GoobankListComponent.vue?vue&type=script&lang=js&"
import style0 from "./GoobankListComponent.vue?vue&type=style&index=0&id=96a2af34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a2af34",
  null
  
)

export default component.exports